import { cn } from '@/lib/utils';
import {
  HEADER_PILL,
  HEADER_PILL_ACTIVE,
  HEADER_PILL_IDLE,
} from '@/shared/components/pillClasses';
import { identityDot } from '../identityFill';
import type { IdentitySlot } from '../modelsLedger';

export interface LegendProfile {
  key: string;
  name: string;
  model: string;
  slot: IdentitySlot;
  /** Not run in the period: a hollow dot (spec 252). */
  idle?: boolean;
}

/**
 * The step map's key (spec 233 US3): each profile's dot and name, and a press that
 * highlights its steps. One at a time; a second press lets go. The board's filter
 * pill (spec 234), since it is one: a toggle, so it says so with `aria-pressed`,
 * and the name is always beside the colour.
 */
export function ProfileLegend({
  profiles,
  pressed,
  onPress,
}: {
  profiles: LegendProfile[];
  pressed: string | null;
  onPress: (key: string | null) => void;
}) {
  return (
    <div
      role="group"
      aria-label="Highlight a profile"
      className="flex flex-wrap gap-1.5"
    >
      {profiles.map((profile) => {
        const on = pressed === profile.key;
        const dot = identityDot(profile);
        return (
          <button
            key={profile.key}
            type="button"
            aria-pressed={on}
            onClick={() => {
              onPress(on ? null : profile.key);
            }}
            className={cn(
              HEADER_PILL,
              on ? HEADER_PILL_ACTIVE : HEADER_PILL_IDLE,
            )}
          >
            <span
              aria-hidden="true"
              data-identity-dot=""
              className={cn('size-2 shrink-0 rounded-full', dot)}
            />
            {profile.name}
          </button>
        );
      })}
    </div>
  );
}
